const getters = {
  pxreports: state => state.pxreport,
};

export default getters;
